import { render, staticRenderFns } from "./addOrderTip.vue?vue&type=template&id=faae02c4&scoped=true&"
import script from "./addOrderTip.vue?vue&type=script&lang=js&"
export * from "./addOrderTip.vue?vue&type=script&lang=js&"
import style0 from "./addOrderTip.vue?vue&type=style&index=0&id=faae02c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faae02c4",
  null
  
)

export default component.exports